import React from 'react';
export function HeroImage() {
  return <section className="w-full" data-id="element-8">
      <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1772736591/hf_20260305_184815_6d262935-621e-4246-bb35-cab8b0ce60f2_g81leb.jpg" alt="Biohacking y Alimentación Consciente" className="w-full block" data-id="element-9" />
    </section>;
}